import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Mail, MapPin, Send, Phone, Clock } from 'lucide-react';

const Kontakt = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    // Create mailto link with form data
    const mailtoLink = `mailto:info@interlingua.app?subject=${encodeURIComponent(formData.subject)}&body=${encodeURIComponent(
      `Name: ${formData.name}\nE-Mail: ${formData.email}\n\nNachricht:\n${formData.message}`
    )}`;
    window.location.href = mailtoLink;
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-emerald-50 via-teal-50 to-cyan-50">
      <div className="container mx-auto px-4 py-8 max-w-6xl">
        
        {/* Header */}
        <div className="mb-8">
          <Link to="/" className="inline-flex items-center text-emerald-600 hover:text-emerald-700 mb-4">
            <ArrowLeft className="w-4 h-4 mr-2" />
            Zurück zur Startseite
          </Link>
          <h1 className="text-4xl font-bold text-gray-900 mb-2">Kontakt</h1>
          <p className="text-gray-600">Wir freuen uns auf Ihre Nachricht!</p>
        </div>

        <div className="grid lg:grid-cols-2 gap-8">
          
          {/* Kontaktformular */}
          <div className="bg-white rounded-lg shadow-lg p-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-6 flex items-center">
              <Send className="w-6 h-6 mr-2 text-emerald-600" />
              Nachricht senden
            </h2>
            
            <form onSubmit={handleSubmit} className="space-y-6">
              <div className="grid md:grid-cols-2 gap-4">
                <div>
                  <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-2">
                    Name *
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    required
                    value={formData.name}
                    onChange={handleChange}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500"
                    placeholder="Ihr vollständiger Name"
                  />
                </div>
                
                <div>
                  <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
                    E-Mail *
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    required
                    value={formData.email}
                    onChange={handleChange}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500"
                    placeholder="ihre.email@beispiel.com"
                  />
                </div>
              </div>
              
              <div>
                <label htmlFor="subject" className="block text-sm font-medium text-gray-700 mb-2">
                  Betreff *
                </label>
                <select
                  id="subject"
                  name="subject"
                  required
                  value={formData.subject}
                  onChange={handleChange}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500"
                >
                  <option value="">Bitte wählen Sie ein Thema</option>
                  <option value="Allgemeine Anfrage">Allgemeine Anfrage</option>
                  <option value="Technischer Support">Technischer Support</option>
                  <option value="Premium-Abonnement">Premium-Abonnement</option>
                  <option value="Datenschutz">Datenschutz</option>
                  <option value="Feedback/Verbesserungsvorschlag">Feedback/Verbesserungsvorschlag</option>
                  <option value="Geschäftsanfrage">Geschäftsanfrage</option>
                  <option value="Presse">Presse</option>
                </select>
              </div>
              
              <div>
                <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-2">
                  Nachricht *
                </label>
                <textarea
                  id="message"
                  name="message"
                  required
                  rows={6}
                  value={formData.message}
                  onChange={handleChange}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500"
                  placeholder="Beschreiben Sie Ihr Anliegen so detailliert wie möglich..."
                ></textarea>
              </div>
              
              <button
                type="submit"
                className="w-full bg-emerald-600 text-white py-3 px-4 rounded-md hover:bg-emerald-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-emerald-500 font-medium transition-colors"
              >
                Nachricht senden
              </button>
              
              <p className="text-sm text-gray-500">
                * Pflichtfelder. Ihre Daten werden gemäß unserer{' '}
                <Link to="/datenschutz" className="text-emerald-600 hover:text-emerald-700">
                  Datenschutzerklärung
                </Link>{' '}
                behandelt.
              </p>
            </form>
          </div>
          
          {/* Kontaktinformationen */}
          <div className="space-y-8">
            
            {/* Direkter Kontakt */}
            <div className="bg-white rounded-lg shadow-lg p-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-6 flex items-center">
                <Mail className="w-6 h-6 mr-2 text-emerald-600" />
                Direkter Kontakt
              </h2>
              
              <div className="space-y-4">
                <div className="flex items-center">
                  <Mail className="w-5 h-5 text-emerald-600 mr-3" />
                  <div>
                    <p className="font-medium text-gray-900">E-Mail</p>
                    <a href="mailto:info@interlingua.app" className="text-emerald-600 hover:text-emerald-700">
                      info@interlingua.app
                    </a>
                  </div>
                </div>
                
                <div className="flex items-center">
                  <MapPin className="w-5 h-5 text-emerald-600 mr-3" />
                  <div>
                    <p className="font-medium text-gray-900">Adresse</p>
                    <p className="text-gray-700">
                      MYSYMP AG<br />
                      CH-6207 Nottwil<br />
                      Schweiz
                    </p>
                  </div>
                </div>
                
                <div className="flex items-center">
                  <Clock className="w-5 h-5 text-emerald-600 mr-3" />
                  <div>
                    <p className="font-medium text-gray-900">Support-Zeiten</p>
                    <p className="text-gray-700">
                      Montag - Freitag: 9:00 - 17:00 CET<br />
                      <span className="text-sm text-gray-500">
                        (Antwort innerhalb von 24 Stunden)
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            
            {/* Häufige Anfragen */}
            <div className="bg-emerald-50 rounded-lg p-8">
              <h3 className="text-xl font-semibold text-emerald-800 mb-4">Häufige Anfragen</h3>
              <div className="space-y-3 text-sm">
                <div>
                  <p className="font-medium text-emerald-800">🚀 Technischer Support</p>
                  <p className="text-emerald-700">Probleme mit der Anmeldung, Audio oder Funktionen</p>
                </div>
                <div>
                  <p className="font-medium text-emerald-800">💎 Premium-Funktionen</p>
                  <p className="text-emerald-700">Fragen zu Abonnements und erweiterten Features</p>
                </div>
                <div>
                  <p className="font-medium text-emerald-800">🔒 Datenschutz</p>
                  <p className="text-emerald-700">Fragen zur Datenverarbeitung und Privatsphäre</p>
                </div>
                <div>
                  <p className="font-medium text-emerald-800">💡 Feedback</p>
                  <p className="text-emerald-700">Verbesserungsvorschläge und Feature-Wünsche</p>
                </div>
              </div>
            </div>
            
            {/* INTERLINGUA.APP Info */}
            <div className="bg-blue-50 rounded-lg p-8">
              <h3 className="text-xl font-semibold text-blue-800 mb-2">Über INTERLINGUA.APP</h3>
              <p className="text-blue-700 text-sm leading-relaxed mb-4">
                INTERLINGUA.APP revolutioniert das Sprachenlernen durch KI-gestützte 
                Technologie. Personalisierte AI-Lehrer, intelligente Spracherkennung und adaptive 
                Lernalgorithmen für optimale Lernergebnisse. Wissenschaftlich fundiert, praktisch anwendbar.
              </p>
              <p className="text-blue-600 text-xs">
                Entwickelt von der MYSYMP AG mit Sitz in der wunderschönen Schweiz 🇨🇭
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Kontakt;